import styled from "styled-components";

export const Container = styled.div`
  background-color: #fafcff;
  position: relative;
  display: flex;
  flex-direction: column;
  @media (max-width: 850px) {
    min-height: calc(100vh - 58px);
  }
`;

export const FleetFindCar = styled.div`
  position: absolute;
  align-self: center;
`;
